import { FaRegCircle, FaDotCircle } from 'react-icons/fa';
import './respostaUnicaEscolha.css';

export default function RespostaUnicaEscolha({
  opcoes = [],
  editable = false,
  onSelect,
  grupo = 'resposta-unica',
}) {
  if (!opcoes.length) {
    return <div className="resposta-vazia">Nenhuma opção selecionada</div>;
  }

  return (
    <div className={`resp-bloco ${!opcoes ? 'vazio' : ''}`}>
      <span className="resp-label">Resposta:</span>
      <div className="w-100">
        <ul className="resposta-unica-lista">
          {opcoes.map((opcao) => {
            const marcada = opcao.opcaoMarcada;

            return (
              <li
                key={opcao.IDQuestao_Opcao}
                className={`resposta-unica-item ${
                  marcada ? 'selecionada' : ''
                }`}
              >
                {editable ? (
                  <label className="resposta-unica-input">
                    <input
                      type="radio"
                      name={grupo}
                      checked={marcada}
                      onChange={() => onSelect?.(opcao)}
                    />
                    <span className="texto">{opcao.descricaoOpcao}</span>
                  </label>
                ) : (
                  <>
                    <span className="icone">
                      {marcada ? (
                        <FaDotCircle size={16} />
                      ) : (
                        <FaRegCircle size={16} />
                      )}
                    </span>

                    <span className="texto">{opcao.descricaoOpcao}</span>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      {/* {opcoes && (
        <div className="resp-datas">
          <small>
            Última Atualização:{' '}
            {opcoes.find((o) => o.opcaoMarcada)?.dataUltimaResposta}
          </small>
        </div>
      )} */}
    </div>
  );
}
